type CodeChild = {
  props: {
    children: string
    className?: string
  }
}

/**
 * Type guard that checks if a value is a CodeChild object.
 * Used to safely type-check and extract code content from markdown code blocks.
 * @param child - The value to check, typically from ReactMarkdown's children prop.
 * @returns True if the value matches the CodeChild type structure.
 */
export const isCodeChild = (child: unknown): child is CodeChild => {
  if (child == null || typeof child !== 'object') return false
  if (!('props' in child)) return false
  const props = (child as CodeChild).props
  return typeof props.children === 'string'
}
